import axios from "axios";

export const closeFingerTemplate = async (state: any, setState: any) => {
    await axios.put(`http://127.0.0.1:15170/fpoperation/${state.opId}/cancel`)
        .then((response) => {
            setState({})
        }, (error) => {
            console.log(error);
        });
}
